import { IMaintenanceSettings } from 'legacy/lut/features/partner360/jbpSettings/models/maintenanceSettings'

import { Nullable } from '../../../../classes/models/utils'
import { parseRawSetting } from '../helpers/parseRawSetting'
import { IParsedMaintenanceSettings } from '../models/parsedMaintenanceSettings'

export const mapMaintenanceSettings = (
  rawMaintenanceSettings: string
): Nullable<IMaintenanceSettings> => {
  const parsedMaintenanceSettings = parseRawSetting<Nullable<IParsedMaintenanceSettings>>({
    setting: rawMaintenanceSettings,
    defaultValue: null,
  })

  if (!parsedMaintenanceSettings) {
    return null
  }

  return {
    icon: parsedMaintenanceSettings.Icon,
    underMaintenance: parsedMaintenanceSettings.UnderMaintenance,
    dateTimeToOpen: parsedMaintenanceSettings.DateTimeToOpen,
    pages: parsedMaintenanceSettings.Pages || [],
  }
}
